import React, { Component } from 'react';
class Banner extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
            <header className="header">
                <div className="publi-banner">
                    <div className="header-green-container"></div>
                    <div className="banner-text">
                        <div className="banner-title">
                            <h1 className="fuente-monserrat"> Publicidad y Mercadeo</h1>
                        </div>
                        {/* <div className="banner-descrip">
                            <p align="justify" className="fuente-monserrat parrafo-grande">
                                La carrera de Publicidad y Mercadeo forma profesionales capacitados para diseñar, crear y aplicar a través de las herramientas del mercadeo y la publicidad, estrategias de crecimiento y comunicación innovadoras y acordes con los tiempos actuales, orientadas a aportar al desarrollo integral de una empresa o institución, y así satisfacer las necesidades del mercado. 
                            </p>
                        </div>
                        <div>
                            <a className="btn btn-danger fuente-monserrat" href="docs/PlanPublicidadMercadeo.pdf" target="_blank" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Descargar el Plan de Estudios">Plan de Estudio <i className="fa fa-download"></i></a>
                        </div> */}
                    </div>
                </div>
            </header>
            </React.Fragment>
        );
    }
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/Banner.jsx